import type { SocialLinks } from './contract.ts';

/** Where each network's profile lives; brands type only the account name after it. */
export const SOCIAL_PREFIX: Record<keyof SocialLinks, string> = {
  facebook: 'https://www.facebook.com/',
  instagram: 'https://www.instagram.com/',
  whatsapp: 'https://wa.me/',
  youtube: 'https://www.youtube.com/@',
  threads: 'https://www.threads.net/@',
  xiaohongshu: 'https://www.xiaohongshu.com/user/profile/',
  linkedin: 'https://www.linkedin.com/company/',
  website: '',
};

/**
 * The link for a social setting: full URLs (older settings, the brand website) are used as they are;
 * an account name gets the network's address in front ("mtrhk" → https://www.facebook.com/mtrhk).
 */
export function socialUrl(kind: keyof SocialLinks, value: string | undefined): string | null {
  const v = value?.trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  if (kind === 'website') return `https://${v}`;
  if (kind === 'whatsapp') return SOCIAL_PREFIX.whatsapp + v.replace(/\D/g, '');
  return SOCIAL_PREFIX[kind] + v.replace(/^@/, '');
}
